export default "__VITE_ASSET__BPBjVFCF__"